import { render, staticRenderFns } from "./worker-tab-title.vue?vue&type=template&id=0b8e5496&"
import script from "./worker-tab-title.vue?vue&type=script&lang=js&"
export * from "./worker-tab-title.vue?vue&type=script&lang=js&"
import style0 from "./worker-tab-title.vue?vue&type=style&index=0&id=0b8e5496&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports